const BYTES_PER_KB = 1024;
const BYTES_PER_MB = BYTES_PER_KB * 1024;
const BYTES_PER_GB = BYTES_PER_MB * 1024;
function stripTrailingZero(value) {
    return value.endsWith('.0') ? value.slice(0, -2) : value;
}
/**
 * Generic byte formatter for the rejected-files alert (`File.size` is only known client-side,
 * pre-queue, so this can't come from the consumer's `AddAttachmentsQueueItem.sizeLabel`). Kept
 * local rather than shared with `frontend/features/BuildingAttachments`'s own
 * `formatFileSize` -- that one lives in feature code and isn't importable from `@ui`.
 */
export function formatBytes(bytes) {
    if (bytes >= BYTES_PER_GB)
        return `${stripTrailingZero((bytes / BYTES_PER_GB).toFixed(1))} GB`;
    if (bytes >= BYTES_PER_MB)
        return `${stripTrailingZero((bytes / BYTES_PER_MB).toFixed(1))} MB`;
    return `${Math.round(bytes / BYTES_PER_KB)} KB`;
}
/** Retry-eligible statuses -- `'unconfirmed'` (bytes landed, finalize didn't confirm) is treated
 *  the same as `'error'` everywhere in this organism; see `types.ts`'s status doc comment. */
export function isRetryable(status) {
    return status === 'error' || status === 'unconfirmed';
}
/** Editing (name/category/visibility) is only meaningful before or between upload attempts.
 *  `'finalizing'` is in-flight work, so it locks the row the same way `'uploading'` does. */
export function isEditable(status) {
    return status !== 'uploading' && status !== 'finalizing' && status !== 'done';
}
